import React from 'react';
import { Grid, Chip, Typography } from '@mui/material';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import renderHTML from 'html-react-parser';
import { Helmet } from 'react-helmet';
import { submissionModelName } from 'utils/contentHelper';

export default class HowItWorksPage extends React.Component {
  render() {
    const { promotion, label, content } = this.props;

    return (
      <React.Fragment>
        <Helmet>
          <title>{promotion.name} | {label}</title>
        </Helmet>

        <Typography variant="h4" align="center" paragraph>{label}</Typography>

        <Typography variant="subtitle1" align="center" className="custom-tab-content">
          {content && renderHTML(content)}
        </Typography>

        <Grid container spacing={2} justifyContent="center" style={{marginTop: '2em'}}>
          <Grid size={12} align="center">
            <Chip label="1" color="primary" style={{marginBottom: '1em'}} />
            <Typography>
              Fill in your details to submit your {submissionModelName(promotion)}
            </Typography>
          </Grid>
          <KeyboardDoubleArrowDownIcon />
          <Grid size={12} align="center">
            <Chip label="2" color="primary" style={{marginBottom: '1em'}} />
            <Typography>
              We will process and validate your submission.
              You will receive an email telling you if your {submissionModelName(promotion)} has been approved or declined
            </Typography>
          </Grid>
          <KeyboardDoubleArrowDownIcon />
          <Grid size={12} align="center">
            <Chip label="3" color="primary" style={{marginBottom: '1em'}} />
            <Typography className="bold">You receive your reward!</Typography>
            <Typography>
              Please note this can take up to {promotion.gift_processing_period} to process
            </Typography>
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }
}
